import { render, staticRenderFns } from "./leadSettle.vue?vue&type=template&id=1bb201c2&scoped=true"
import script from "./leadSettle.vue?vue&type=script&lang=js"
export * from "./leadSettle.vue?vue&type=script&lang=js"
import style0 from "./leadSettle.vue?vue&type=style&index=0&id=1bb201c2&prod&lang=less&scoped=true"
import style1 from "./leadSettle.vue?vue&type=style&index=1&id=1bb201c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb201c2",
  null
  
)

export default component.exports